import React, { useState, useCallback, useEffect, forwardRef } from "react";
import { FormLayout, TextField, Text, RangeSlider } from "@shopify/polaris";
import { HexColorPicker } from "react-colorful";

const ShadowStyle = (props) => {
  const handleSelectChangeShadowColor = (newValue) => {
    props.handleSelectChangeShadowColor(newValue);
  };
  const handleChangeShadowOpacity = (newValue) => {
    props.handleChangeShadowOpacity(newValue);
  };
  const handleChangeShadowBlurRadius = (newValue) => {
    props.handleChangeShadowBlurRadius(newValue);
  };
  return (
    <FormLayout>
      <Text variant="headingSm" as="h6">
        SHADOW STYLE
      </Text>
      <Text as="p" fontWeight="medium">
        Color
      </Text>
      <HexColorPicker
        color={props?.item?.shadow?.color ? props?.item?.shadow?.color : ""}
        onChange={handleSelectChangeShadowColor}
      />
      <TextField
        value={props?.item?.shadow?.color ? props?.item?.shadow?.color : ""}
        onChange={handleSelectChangeShadowColor}
      />
      <Text as="p" fontWeight="medium">
        Blur Radius
      </Text>
      <TextField
        value={
          props?.item?.shadow?.blurRadius ? props?.item?.shadow?.blurRadius : ""
        }
        onChange={handleChangeShadowBlurRadius}
      />
      <RangeSlider
        output
        label="Opacity Percentage"
        min={0}
        max={100}
        value={props?.item?.shadow?.opacity ? props?.item?.shadow?.opacity : ""}
        onChange={handleChangeShadowOpacity}
        suffix={
          <p
            style={{
              minWidth: "24px",
              textAlign: "right",
            }}
          >
            {props?.item?.shadow?.opacity ? props?.item?.shadow?.opacity : ""}
          </p>
        }
      />
    </FormLayout>
  );
};

export default ShadowStyle;
